var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Banner, IconButton, Text } from '@dixa/lib-shared-habla';
import { useContext } from 'react';
import { appActions } from 'app/app.actions';
import { KeyboardKeyCombinations } from 'components/keyboard';
import { useCommands } from 'utils/commands';
import { createPrettyKeyCombination, } from 'utils/keyboard';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { KeyboardKeybindingsTableRowContext } from '../../utils/keyboardKeybindingsTableRowContext';
/** Represents the component for editing the keybindings of a command. */
export const EditKeybindingsAction = () => {
    const dispatch = useAppDispatch();
    const { setKeybindings, enrichedCommands } = useCommands();
    const { enrichedCommand: { command: { label, name }, isKeyboardRebindable, }, } = useContext(KeyboardKeybindingsTableRowContext);
    const isNonRebindable = !isKeyboardRebindable;
    const description = (_jsxs(_Fragment, { children: [_jsxs(Text.Paragraph, Object.assign({ variant: "4" }, { children: ["Record and assign new keybinding for ", _jsx("strong", { children: label }), " command."] })), _jsxs(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: ["Note that recording of certain key combinations could conflict with the browser and/or operating system native keyboard shortcuts, e.g.", ' ', _jsx(KeyboardKeyCombinations, { keyCombinations: [
                            { binding: [['$metaOrCtrl'], 'Digit1'] },
                            { binding: [['$metaOrCtrl'], 'KeyT'] },
                            { binding: [['$metaOrCtrl'], 'KeyW'] },
                        ] })] }))] }));
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        const conflictFn = (keyCombination) => {
            const conflict = enrichedCommands.find(({ command: { keyboard } }) => {
                const keybindings = keyboard === null || keyboard === void 0 ? void 0 : keyboard.keybindings;
                if (keybindings) {
                    return compareKeyCombinations(keyCombination, keybindings);
                }
            });
            if (conflict) {
                return {
                    message: (_jsx(Banner, { variant: "warning", description: _jsxs(Text.Paragraph, Object.assign({ variant: "4" }, { children: ["This key combination is already assigned to", ' ', _jsx("strong", { children: conflict.command.label }), " command"] })) })),
                };
            }
            return false;
        };
        const { keyCombination, isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:keyCombinationRecorder',
                arg: {
                    title: 'Assign new keybinding',
                    description,
                    confirm: {
                        label: 'Assign',
                    },
                    conflictFn,
                },
            },
        }));
        if (isConfirmed && keyCombination) {
            setKeybindings(name, [keyCombination]);
        }
    });
    return (_jsx(IconButton, { icon: "pen", variant: "tertiary", disabled: isNonRebindable, onClick: () => handleClick() }));
};
/**
 * Checks whether the given source key combination is already present in the
 * given target list of key combinations.
 *
 * @param a The source key combination.
 * @param b The target list of key combinations.
 */
function compareKeyCombinations(a, b) {
    var _a;
    const aString = (_a = createPrettyKeyCombination(a, {
        preferBinding: true,
    })) === null || _a === void 0 ? void 0 : _a.toString();
    return b.some((keyCombination) => {
        var _a;
        const bString = (_a = createPrettyKeyCombination(keyCombination, {
            preferBinding: true,
        })) === null || _a === void 0 ? void 0 : _a.toString();
        return aString === bString;
    });
}
